import axios from 'axios';
import { useState } from 'react';
import { getFilenameFromContentDisposition } from '../helpers/getFilenameFromContentDisposition';
import { PageObject } from 'data/v3/data-contracts';

export type PagePdfExportConfig = {
  includeCoverPage: boolean;
};

const usePagePdfExport = () => {
  const [isExporting, setIsExporting] = useState(false);

  const handlePdfExport = async ({
    pageId,
    options = {
      includeCoverPage: false,
    },
    onSuccess = () => {},
  }: {
    pageId: PageObject['id'];
    options: PagePdfExportConfig;
    onSuccess?: () => void;
  }) => {
    try {
      setIsExporting(true);

      const response = await axios.post(
        `/v3/pages/${pageId}/pdf/exports`,
        {
          include_cover_page: options.includeCoverPage,
        },
        { responseType: 'blob', withCredentials: true },
      );

      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      const filename = getFilenameFromContentDisposition(contentDisposition);

      const blob = new Blob([response.data], {
        type: 'application/octet-stream',
      });

      // Downloads the file with a set filename
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      setIsExporting(false);
      onSuccess();
    } catch (error) {
      setIsExporting(false);
    }
  };

  return { isExporting, handlePdfExport };
};

export default usePagePdfExport;
